import { render, staticRenderFns } from "./master-user.vue?vue&type=template&id=6cf64883&"
import script from "./master-user.vue?vue&type=script&lang=js&"
export * from "./master-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports